import * as React from "react"
import {TextFieldSeeker} from "@ui-seeker/core";

import {repricingSearchText} from "../../@signals";


export default function RepricingSearchTextField() {

	return <TextFieldSeeker
		placeholder="Search..."
		value={repricingSearchText.value}
		onChange={e => repricingSearchText.value = e.target.value}
		startIcon="search"
	/>
}